// @ts-nocheck
import constants from "@store/constants";

export const excludedPageTypesAccountMenu = [constants.pageType.addresses, constants.pageType.invoiceHistory];

export const excludedPage = (rootPageLink: any, excludedPageTypes: string[] = excludedPageTypesAccountMenu) => {
    const _links = rootPageLink?.children?.filter(
        (x: { excludeFromNavigation: any; type: string }) =>
            !x.excludeFromNavigation && !excludedPageTypes.some(y => x.type === y),
    );

    return _links;
};
